module.exports = __webpack_public_path__ + "static/media/15.70f7138b.jpg";